import { createAssignment } from './create'
import { deleteAssignment } from './delete'
import { readAssignmentById } from './read'
import { resourceObject } from './resourceObject'
import { updateAssignment } from './update'

export const assignments = {
  create: createAssignment,
  readSingle: readAssignmentById,
  resourceObject,
  update: updateAssignment,
  delete: deleteAssignment,
}
